<template>
    <div class="content">
        <base-header class="pb-6 bg-gradient-info">
            <b-row align-v="center" class="py-4">
                <b-col cols="7" lg="6">
                    <h6 :class="AppStyle.BREADCRUMB_H_STYLE" class="h2 d-inline-block mb-0">Art Book {{ photo_book.id }}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-bread-crumb></route-bread-crumb>
                    </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">

            <div>

                <div class="loader" v-if="loading"></div>

            </div>

        </b-container>
    </div>
</template>
<script>

import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import Badge from '@/components/Badge';
import { Tabs, TabPane } from '@/components';

import DamageHistory from '../Components/DamageHistory';
import Comments from '../cscomponents/Comments';

import AppStyle from '@/plugins/appStyle';

export default {
    mixins: [AppStyle.Mixin],
    components: {
        RouteBreadCrumb,
        Badge,
        DamageHistory,
        Tabs,
        TabPane,
        Comments,
    },
    data() {
        return {
            loading: true,
            photoBook: null,
            actiTab: 'Dokumente',
        }
    },
    props: {
        token: String,
    },
    methods: {
        retrievePhotoBook() {
            this.loading = true;
            this.$api.getPhotoBook(this.token)
                .then((response) => {
                    this.photoBook = response.data.photo_book;
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                   // this.toggleAllRows();
                });
        },



        downloadFile(id, name) {
            this.$api.getDocument(id).then(response => {
                const blob = new Blob([response.data])
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.setAttribute('download', this.fileName(name));
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },



    },
    channels: {
        ClaimsChannel: {
            connected() {
                //console.log('I am connected to claims');
            },
            rejected() {
                //console.log('I am REJECTED.');
            },
            received(data) {
                //        console.log("RECEIVED!");
                //        console.log(data);
                // switch case if documents_generated
                // switch case if documents_signed
                // do something on receive... check if docs generated
                if (data.action == "signed") {
                    this.claim.attachments = data.payload;
                    this.claim.documents_signed = true;
                }

                if (data.action == "generated") {
                    this.claim.attachments = data.payload;
                    this.claim.documents_generated = true;
                }
            },
            disconnected() {
                console.log('I am disconnected.');
            }
        }
    },
    computed: {
    },
    mounted() {
        this.$cable.subscribe({
            channel: 'ClaimsChannel',
            claim_id: this.token,
        });
        this.retrieveClaim();

        this.actiTab = 'dokumente'
        this.$refs.tabbi = 'dokumente';

    },
    created() {
    },
}
</script>